import script from "./ApprovalEmp.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalEmp.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalEmp.vue?vue&type=style&index=0&id=707cb459&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-707cb459"]])

export default __exports__